
import React from "react";
import { BellIcon } from "@heroicons/react/24/outline";

export default function NotificationBell({ count = 0, onClick }) {

    return (
        <button
            className="relative flex h-10 w-10 items-center justify-center rounded-full transition hover:bg-gray-100 focus:outline-none"
            onClick={onClick}
            aria-label="Notifications"
        >
            <BellIcon className="w-6 h-6 text-gray-700" />
            {count > 0 && (
                <span className="absolute -right-1 -top-1 inline-flex h-5 min-w-5 items-center justify-center rounded-full bg-red-500 px-1 text-[10px] font-bold leading-none text-white ring-2 ring-white">
                    {count > 99 ? "99+" : count}
                </span>
            )}
        </button>
    );
}
